import styled from 'styled-components';

export const LayoutMainComponent = styled.main``;
